import { useState, useEffect } from "react";

const useTableShadow = (containerRef) => {
  const [showActionShadow, setShowActionShadow] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (containerRef.current) {
        const tableDiv = containerRef.current.querySelector(".APP-TABLE");
        if (tableDiv) {
          const { scrollLeft, scrollWidth, clientWidth } = tableDiv;
          // Show shadow if we are NOT at the very end of horizontal scroll (tolerance of 1px)
          const isAtEnd = Math.abs(scrollWidth - clientWidth - scrollLeft) <= 1;
          setShowActionShadow(!isAtEnd && scrollWidth > clientWidth);
        }
      }
    };

    checkScroll();

    // Attach listener manually since we might not have direct ref to the scrolling div easily via props
    const tableDiv = containerRef.current?.querySelector(".APP-TABLE");
    if (tableDiv) {
      tableDiv.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
    }
    return () => {
      if (tableDiv) {
        tableDiv.removeEventListener("scroll", checkScroll);
      }
      window.removeEventListener("resize", checkScroll);
    };
  });

  return showActionShadow;
};

export default useTableShadow;
